import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { easeOut } from "@/components/common/Reveal";
import { BLOG_POSTS } from "@/data/blog";

const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });

export default function BlogPreview() {
  const latest = BLOG_POSTS.slice(0, 3);
  return (
    <section className="bg-slate-50 py-24 lg:py-32" data-testid="blog-preview">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 lg:flex-row lg:items-end">
          <SectionHeading eyebrow="Actualités & conseils" title="Le blog EDUCASER GROUP" />
          <Link to="/blog"
            className="inline-flex items-center gap-2 rounded-full border border-brand-blue/20 px-5 py-2.5 text-sm font-semibold text-brand-blue transition-colors hover:bg-brand-blue hover:text-white"
            data-testid="blog-preview-all">
            Voir tous les articles <ArrowRight className="h-4 w-4" />
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {latest.map((post, i) => (
            <motion.article
              key={post.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, ease: easeOut, delay: i * 0.08 }}
              className="group flex flex-col overflow-hidden rounded-2xl bg-white shadow-[0_10px_30px_rgba(0,35,102,0.06)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_50px_rgba(0,35,102,0.12)]"
            >
              <Link to={`/blog/${post.slug}`}>
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={post.cover} alt={post.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy" />
                  <span className="absolute left-4 top-4 rounded-full bg-brand-red px-3 py-1 text-xs font-semibold text-white">
                    {post.category}
                  </span>
                </div>
              </Link>
              <div className="flex flex-1 flex-col p-6">
                <div className="flex items-center gap-4 text-xs text-slate-400">
                  <span className="inline-flex items-center gap-1"><Calendar className="h-3.5 w-3.5" /> {fmtDate(post.publishedAt)}</span>
                  <span className="inline-flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {post.readingTime} min</span>
                </div>
                <h3 className="mt-3 font-display text-lg font-bold text-brand-blue transition-colors group-hover:text-brand-red">
                  <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-500">{post.excerpt}</p>
                <Link to={`/blog/${post.slug}`}
                  className="mt-4 inline-flex w-fit items-center gap-1.5 text-sm font-semibold text-brand-red hover:text-brand-red-light">
                  Lire l'article <ArrowRight className="h-3.5 w-3.5" />
                </Link>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
